// import axios from "axios";
// import toast from "react-hot-toast";

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// /* =========================================================
//    ACTION TYPES
// ========================================================= */

// // Attendance list
// export const FETCH_ATTENDANCE_REQUEST = "FETCH_ATTENDANCE_REQUEST";
// export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
// export const FETCH_ATTENDANCE_FAILURE = "FETCH_ATTENDANCE_FAILURE";

// // Papers
// export const FETCH_PAPERS_REQUEST = "FETCH_PAPERS_REQUEST";
// export const FETCH_PAPERS_SUCCESS = "FETCH_PAPERS_SUCCESS";
// export const FETCH_PAPERS_FAILURE = "FETCH_PAPERS_FAILURE";

// // Paper summary
// export const FETCH_PAPER_SUMMARY_REQUEST = "FETCH_PAPER_SUMMARY_REQUEST";
// export const FETCH_PAPER_SUMMARY_SUCCESS = "FETCH_PAPER_SUMMARY_SUCCESS";
// export const FETCH_PAPER_SUMMARY_FAILURE = "FETCH_PAPER_SUMMARY_FAILURE";

// // Semester summary
// export const FETCH_SEM_SUMMARY_REQUEST = "FETCH_SEM_SUMMARY_REQUEST";
// export const FETCH_SEM_SUMMARY_SUCCESS = "FETCH_SEM_SUMMARY_SUCCESS";
// export const FETCH_SEM_SUMMARY_FAILURE = "FETCH_SEM_SUMMARY_FAILURE";

// // Subjects
// export const FETCH_SUBJECTS_REQUEST = "FETCH_SUBJECTS_REQUEST";
// export const FETCH_SUBJECTS_SUCCESS = "FETCH_SUBJECTS_SUCCESS";
// export const FETCH_SUBJECTS_FAILURE = "FETCH_SUBJECTS_FAILURE";

// /* =========================================================
//    FETCH ATTENDANCE LIST
// ========================================================= */
// export const fetchAttendance = ({
//   page = 1,
//   limit = 10,
//   fromDate = "",
//   toDate = "",
//   search = "",
//   sem = "",
//   is_hons = "",
//   period = "",
// } = {}) => async (dispatch) => {
//   dispatch({ type: FETCH_ATTENDANCE_REQUEST });

//   const token = localStorage.getItem("token");

//   try {
//     const queryParams = new URLSearchParams({
//       page,
//       limit,
//       fromDate,
//       toDate,
//       search,
//       sem,
//       is_hons,
//       period,
//     }).toString();

//     const response = await axios.get(
//       `${BASE_URL}/v1/api/admin/attendance?${queryParams}`,
//       { headers: { Authorization: token } }
//     );

//     dispatch({
//       type: FETCH_ATTENDANCE_SUCCESS,
//       payload: {
//         attendance: response.data.data,
//         pagination: response.data.meta?.pagination || {},
//       },
//     });
//   } catch (error) {
//     const message =
//       error?.response?.data?.meta?.message ||
//       error?.response?.data?.message ||
//       error.message ||
//       "Failed to fetch attendance";

//     dispatch({ type: FETCH_ATTENDANCE_FAILURE, payload: message });
//     toast.error(message);
//   }
// };

// /* =========================================================
//    FETCH PAPERS
// ========================================================= */
// // export const fetchPapers = () => async (dispatch) => {
// //   dispatch({ type: FETCH_PAPERS_REQUEST });

// //   const token = localStorage.getItem("token");

// //   try {
// //     const response = await axios.get(
// //       `${BASE_URL}/v1/api/academic/papers`,
// //       { headers: { Authorization: token } }
// //     );

// //     dispatch({
// //       type: FETCH_PAPERS_SUCCESS,
// //       payload: response.data.data,
// //     });
// //   } catch (error) {
// //     const message =
// //       error?.response?.data?.meta?.message ||
// //       error?.response?.data?.message ||
// //       error.message ||
// //       "Failed to fetch papers";

// //     dispatch({ type: FETCH_PAPERS_FAILURE, payload: message });
// //     toast.error(message);
// //   }
// // };
// /* =========================================================
//    FETCH PAPERS
// ========================================================= */
// export const fetchPapers = (subject_id = "") => async (dispatch) => {
//   dispatch({ type: FETCH_PAPERS_REQUEST });

//   const token = localStorage.getItem("token");

//   try {

//     const queryParams = new URLSearchParams({
//       subject_id,
//     }).toString();

//     const response = await axios.get(
//       `${BASE_URL}/v1/api/academic/papers?${queryParams}`,
//       { headers: { Authorization: token } }
//     );

//     dispatch({
//       type: FETCH_PAPERS_SUCCESS,
//       payload: response.data.data,
//     });

//   } catch (error) {
//     const message =
//       error?.response?.data?.meta?.message ||
//       error?.response?.data?.message ||
//       error.message ||
//       "Failed to fetch papers";

//     dispatch({ type: FETCH_PAPERS_FAILURE, payload: message });
//     toast.error(message);
//   }
// };
// /* =========================================================
//    PAPER WISE ATTENDANCE SUMMARY
// ========================================================= */
// export const fetchPaperSummary = ({
//   paper_id,
//   fromDate = "",
//   toDate = "",
//   page = 1,
//   limit = 10,
// }) => async (dispatch) => {
//   dispatch({ type: FETCH_PAPER_SUMMARY_REQUEST });

//   const token = localStorage.getItem("token");

//   try {
//     const queryParams = new URLSearchParams({
//       paper_id,
//       fromDate,
//       toDate,
//       page,
//       limit,
//     }).toString();

//     const response = await axios.get(
//       `${BASE_URL}/v1/api/admin/attendance/paper-summary?${queryParams}`,
//       { headers: { Authorization: token } }
//     );

//     dispatch({
//       type: FETCH_PAPER_SUMMARY_SUCCESS,
//       payload: {
//         students: response.data.data,
//         paperName: response.data.paper_name,
//         teacherName: response.data.teacher_name,
//         teacherContact: response.data.teacher_contact_no,
//         summary: response.data.summary,
//         pagination: response.data.meta?.pagination || {},
//       },
//     });
//   } catch (error) {
//     const message =
//       error?.response?.data?.meta?.message ||
//       error?.response?.data?.message ||
//       error.message ||
//       "Failed to fetch paper summary";

//     dispatch({ type: FETCH_PAPER_SUMMARY_FAILURE, payload: message });
//     toast.error(message);
//   }
// };

// /* =========================================================
//    SEMESTER WISE ATTENDANCE SUMMARY
// ========================================================= */

// export const fetchSemesterSummary = ({
//   sem,
//   page = 1,
//   limit = 10,
// }) => async (dispatch) => {
//   dispatch({ type: FETCH_SEM_SUMMARY_REQUEST });

//   const token = localStorage.getItem("token");

//   try {
//     const queryParams = new URLSearchParams({
//       sem,
//       page,
//       limit,
//     }).toString();

//     const response = await axios.get(
//       `${BASE_URL}/v1/api/admin/attendance/sem-summary?${queryParams}`,
//       { headers: { Authorization: token } }
//     );

//     dispatch({
//       type: FETCH_SEM_SUMMARY_SUCCESS,
//       payload: {
//         students: response.data.data,
//         summary: response.data.summary,
//         pagination: response.data.meta?.pagination || {},
//       },
//     });
//   } catch (error) {
//     const message =
//       error?.response?.data?.meta?.message ||
//       error?.response?.data?.message ||
//       error.message ||
//       "Failed to fetch semester summary";

//     dispatch({ type: FETCH_SEM_SUMMARY_FAILURE, payload: message });
//     toast.error(message);
//   }
// };

// /* =========================================================
//    FETCH SUBJECTS
// ========================================================= */
// export const fetchSubjects = () => async (dispatch) => {
//   dispatch({ type: FETCH_SUBJECTS_REQUEST });

//   const token = localStorage.getItem("token");

//   try {
//     const response = await axios.get(
//       `${BASE_URL}/v1/api/academic/subjects`,
//       { headers: { Authorization: token } }
//     );

//     dispatch({
//       type: FETCH_SUBJECTS_SUCCESS,
//       payload: response.data.data,
//     });

//   } catch (error) {
//     const message =
//       error?.response?.data?.meta?.message ||
//       error?.response?.data?.message ||
//       error.message ||
//       "Failed to fetch subjects";

//     dispatch({ type: FETCH_SUBJECTS_FAILURE, payload: message });
//     toast.error(message);
//   }
// };
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* =========================================================
   ACTION TYPES
========================================================= */

// Attendance list
export const FETCH_ATTENDANCE_REQUEST = "FETCH_ATTENDANCE_REQUEST";
export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
export const FETCH_ATTENDANCE_FAILURE = "FETCH_ATTENDANCE_FAILURE";

// Papers
export const FETCH_PAPERS_REQUEST = "FETCH_PAPERS_REQUEST";
export const FETCH_PAPERS_SUCCESS = "FETCH_PAPERS_SUCCESS";
export const FETCH_PAPERS_FAILURE = "FETCH_PAPERS_FAILURE";

// Paper summary
export const FETCH_PAPER_SUMMARY_REQUEST = "FETCH_PAPER_SUMMARY_REQUEST";
export const FETCH_PAPER_SUMMARY_SUCCESS = "FETCH_PAPER_SUMMARY_SUCCESS";
export const FETCH_PAPER_SUMMARY_FAILURE = "FETCH_PAPER_SUMMARY_FAILURE";

// Semester summary
export const FETCH_SEM_SUMMARY_REQUEST = "FETCH_SEM_SUMMARY_REQUEST";
export const FETCH_SEM_SUMMARY_SUCCESS = "FETCH_SEM_SUMMARY_SUCCESS";
export const FETCH_SEM_SUMMARY_FAILURE = "FETCH_SEM_SUMMARY_FAILURE";

// Subjects
export const FETCH_SUBJECTS_REQUEST = "FETCH_SUBJECTS_REQUEST";
export const FETCH_SUBJECTS_SUCCESS = "FETCH_SUBJECTS_SUCCESS";
export const FETCH_SUBJECTS_FAILURE = "FETCH_SUBJECTS_FAILURE";

// Student Paper Summary (for modal)
export const FETCH_STUDENT_PAPER_SUMMARY_REQUEST =
  "FETCH_STUDENT_PAPER_SUMMARY_REQUEST";
export const FETCH_STUDENT_PAPER_SUMMARY_SUCCESS =
  "FETCH_STUDENT_PAPER_SUMMARY_SUCCESS";
export const FETCH_STUDENT_PAPER_SUMMARY_FAILURE =
  "FETCH_STUDENT_PAPER_SUMMARY_FAILURE";

//department report
export const FETCH_DEPARTMENT_REPORT_REQUEST =
  "FETCH_DEPARTMENT_REPORT_REQUEST";
export const FETCH_DEPARTMENT_REPORT_SUCCESS =
  "FETCH_DEPARTMENT_REPORT_SUCCESS";
export const FETCH_DEPARTMENT_REPORT_FAILURE =
  "FETCH_DEPARTMENT_REPORT_FAILURE";
export const CLEAR_DEPARTMENT_REPORT = "CLEAR_DEPARTMENT_REPORT";

export const FETCH_SESSION_LIST_REQUEST = "FETCH_SESSION_LIST_REQUEST";
export const FETCH_SESSION_LIST_SUCCESS = "FETCH_SESSION_LIST_SUCCESS";
export const FETCH_SESSION_LIST_FAILURE = "FETCH_SESSION_LIST_FAILURE";

export const FETCH_PROGRAMMES_REQUEST = "FETCH_PROGRAMMES_REQUEST";
export const FETCH_PROGRAMMES_SUCCESS = "FETCH_PROGRAMMES_SUCCESS";
export const FETCH_PROGRAMMES_FAILURE = "FETCH_PROGRAMMES_FAILURE";

/* =========================================================
   FETCH ATTENDANCE LIST
========================================================= */
export const fetchPapersBySubject = (subjectId) => async (dispatch) => {
  const response = await axios.get(`/api/subjects/${subjectId}/papers`);
  return response.data;
};

export const fetchAttendance =
  ({
    page = 1,
    limit = 10,
    fromDate = "",
    toDate = "",
    search = "",
    sem = "",
    is_hons = "",
    period = "",
    class_type = "",
    paper_id = "",
    subject_id = "",
  } = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_ATTENDANCE_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams({
        page,
        limit,
        fromDate,
        toDate,
        search,
        sem,
        is_hons,
        period,
        class_type,
        paper_id,
        subject_id,
      }).toString();

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/attendance?${queryParams}`,
        { headers: { Authorization: token } },
      );

      dispatch({
        type: FETCH_ATTENDANCE_SUCCESS,
        payload: {
          attendance: response.data.data,
          pagination: response.data.meta?.pagination || {},
        },
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch attendance";

      dispatch({ type: FETCH_ATTENDANCE_FAILURE, payload: message });
      toast.error(message);
    }
  };

/* =========================================================
   FETCH SUBJECTS
========================================================= */
export const fetchSubjects = () => async (dispatch) => {
  dispatch({ type: FETCH_SUBJECTS_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/academic/subjects`, {
      headers: { Authorization: token },
    });

    dispatch({
      type: FETCH_SUBJECTS_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    const message =
      error?.response?.data?.meta?.message ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch subjects";

    dispatch({ type: FETCH_SUBJECTS_FAILURE, payload: message });
    toast.error(message);
  }
};

/* =========================================================
   FETCH PAPERS (Updated to optionally filter by subject)
========================================================= */
export const fetchPapers =
  (subject_id = "") =>
  async (dispatch) => {
    dispatch({ type: FETCH_PAPERS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      // Build query params - only add subject_id if it's provided
      const queryParams = new URLSearchParams();
      if (subject_id) {
        queryParams.append("subject_id", subject_id);
      }

      const response = await axios.get(
        `${BASE_URL}/v1/api/academic/papers${queryParams.toString() ? `?${queryParams.toString()}` : ""}`,
        { headers: { Authorization: token } },
      );

      dispatch({
        type: FETCH_PAPERS_SUCCESS,
        payload: response.data.data,
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch papers";

      dispatch({ type: FETCH_PAPERS_FAILURE, payload: message });
      toast.error(message);
    }
  };

/* =========================================================
   PAPER WISE ATTENDANCE SUMMARY
========================================================= */
export const fetchPaperSummary =
  ({
    paper_id,
    fromDate = "",
    toDate = "",
    page = 1,
    limit = 10,
    class_type = "",
  }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_PAPER_SUMMARY_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams({
        paper_id,
        fromDate,
        toDate,
        page,
        limit,
        class_type,
      }).toString();

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/attendance/paper-summary?${queryParams}`,
        { headers: { Authorization: token } },
      );

      dispatch({
        type: FETCH_PAPER_SUMMARY_SUCCESS,
        payload: {
          students: response.data.data,
          paperName: response.data.paper_name,
          teacherName: response.data.teacher_name,
          teacherContact: response.data.teacher_contact_no,
          summary: response.data.summary,
          pagination: response.data.meta?.pagination || {},
        },
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch paper summary";

      dispatch({ type: FETCH_PAPER_SUMMARY_FAILURE, payload: message });
      toast.error(message);
    }
  };

/* =========================================================
   SEMESTER WISE ATTENDANCE SUMMARY
========================================================= */
// export const fetchSemesterSummary =
//   ({ sem, page = 1, limit = 10, class_type = "" }) =>
//   async (dispatch) => {
//     dispatch({ type: FETCH_SEM_SUMMARY_REQUEST });

//     const token = localStorage.getItem("token");

//     try {
//       const queryParams = new URLSearchParams({
//         sem,
//         page,
//         limit,
//         class_type,
//       }).toString();

//       const response = await axios.get(
//         `${BASE_URL}/v1/api/admin/attendance/sem-summary?${queryParams}`,
//         { headers: { Authorization: token } },
//       );

//       dispatch({
//         type: FETCH_SEM_SUMMARY_SUCCESS,
//         payload: {
//           students: response.data.data,
//           summary: response.data.summary,
//           pagination: response.data.meta?.pagination || {},
//         },
//       });
//     } catch (error) {
//       const message =
//         error?.response?.data?.meta?.message ||
//         error?.response?.data?.message ||
//         error.message ||
//         "Failed to fetch semester summary";

//       dispatch({ type: FETCH_SEM_SUMMARY_FAILURE, payload: message });
//       toast.error(message);
//     }
//   };

/* =========================================================
   STUDENT PAPER WISE ATTENDANCE SUMMARY (for modal view)
========================================================= */
export const fetchStudentPaperSummary =
  ({ student_id, paper_id }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_STUDENT_PAPER_SUMMARY_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams({
        student_id,
        paper_id,
      }).toString();

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/attendance/student-paper-summary?${queryParams}`,
        { headers: { Authorization: token } },
      );

      dispatch({
        type: FETCH_STUDENT_PAPER_SUMMARY_SUCCESS,
        payload: {
          studentData: response.data.data,
          paperName: response.data.paper_name,
          teacherName: response.data.teacher_name,
          teacherContact: response.data.teacher_contact_no,
          summary: response.data.summary,
        },
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch student paper summary";

      dispatch({ type: FETCH_STUDENT_PAPER_SUMMARY_FAILURE, payload: message });
      toast.error(message);
    }
  };

export const fetchSemesterSummary =
  ({ sem, page = 1, limit = 10, class_type = "", from_date, to_date }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_SEM_SUMMARY_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams({
        sem,
        page,
        limit,
        class_type,
      });

      // Add optional date filters only if provided
      if (from_date) queryParams.append("from_date", from_date);
      if (to_date) queryParams.append("to_date", to_date);

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/attendance/sem-summary?${queryParams.toString()}`,
        { headers: { Authorization: token } },
      );

      dispatch({
        type: FETCH_SEM_SUMMARY_SUCCESS,
        payload: {
          students: response.data.data,
          summary: response.data.summary,
          pagination: response.data.meta?.pagination || {},
        },
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch semester summary";

      dispatch({ type: FETCH_SEM_SUMMARY_FAILURE, payload: message });
      toast.error(message);
    }
  };
/* =========================================================
   DEPARTMENT WISE ATTENDANCE SUMMARY
========================================================= */
export const fetchDepartmentWiseReport =
  ({ sem, session_id, programme_id, page = 1, limit = 10 }) =>
  async (dispatch) => {
    dispatch({ type: FETCH_DEPARTMENT_REPORT_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams({
        sem,
        session_id,
        programme_id,
        page,
        limit,
      }).toString();

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/report/department-wise?${queryParams}`,
        { headers: { Authorization: token } },
      );

      dispatch({
        type: FETCH_DEPARTMENT_REPORT_SUCCESS,
        payload: {
          data: response.data.data,
          pagination: response.data.meta?.pagination || {},
        },
      });
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Failed to fetch department wise report";

      dispatch({ type: FETCH_DEPARTMENT_REPORT_FAILURE, payload: message });
      toast.error(message);
    }
  };

/* =========================================================
   CLEAR DEPARTMENT REPORT
========================================================= */
export const clearDepartmentReport = () => (dispatch) => {
  dispatch({ type: CLEAR_DEPARTMENT_REPORT });
};

/* =========================================================
   FETCH SESSION LIST
========================================================= */
export const fetchSessionList = () => async (dispatch) => {
  dispatch({ type: FETCH_SESSION_LIST_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${BASE_URL}/v1/api/academic/session-list`,
      { headers: { Authorization: token } },
    );

    dispatch({
      type: FETCH_SESSION_LIST_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    const message =
      error?.response?.data?.meta?.message ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch session list";

    dispatch({ type: FETCH_SESSION_LIST_FAILURE, payload: message });
    toast.error(message);
  }
};

/* =========================================================
   FETCH PROGRAMMES
========================================================= */
export const fetchProgrammes = () => async (dispatch) => {
  dispatch({ type: FETCH_PROGRAMMES_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.get(`${BASE_URL}/v1/api/admin/programmes`, {
      headers: { Authorization: token },
    });

    dispatch({
      type: FETCH_PROGRAMMES_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    const message =
      error?.response?.data?.meta?.message ||
      error?.response?.data?.message ||
      error.message ||
      "Failed to fetch programmes";

    dispatch({ type: FETCH_PROGRAMMES_FAILURE, payload: message });
    toast.error(message);
  }
};
